<num-dataportal-header role="banner"></num-dataportal-header>
<mat-sidenav-container autosize fullscreen class="sidenav-container fix-overlay">
  @if (showSideNav) {
  <mat-sidenav
    fixedInViewport
    [attr.role]="isHandset ? 'dialog' : 'navigation'"
    [attr.aria-label]="'APPLAYOUT.SIDENAV.LABEL' | translate"
    [mode]="isHandset ? 'over' : 'side'"
    [opened]="true"
    [class.expanded]="isSideMenuExpanded"
    [class.collapsed]="!isSideMenuExpanded"
  >
    <num-side-menu
      class="side-menu logo-wrapper"
      [isSideMenuExpanded]="isSideMenuExpanded"
      (toggleSideMenu)="isSideMenuExpanded = $event"
    ></num-side-menu>
  </mat-sidenav>
  }

  <mat-sidenav-content class="padding-left-4">
    <div role="presentation" class="content-row">
      <main class="main-content">
        <div [@routeAnimations]="prepareRoute(outlet)" class="fullscreen">
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </main>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
